//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "PdfPreviewDialog",
  props: {
    value: { type: Boolean, default: false },
    blob: { type: Blob, default: null },
    filename: { type: String, default: "document.pdf" },
    zoom: { type: [String, Number], default: 75 },
  },
  data() {
    return {
      pdfUrl: "",
      zoomLevel: Number(this.zoom) || 75,
    };
  },
  watch: {
    blob: {
      immediate: true,
      handler(val) {
        this.revoke();
        if (val) this.pdfUrl = URL.createObjectURL(val);
      },
    },
    value(val) {
      if (val) this.zoomLevel = Number(this.zoom) || 75;
      else this.revoke();
    },
  },
  beforeDestroy() {
    this.revoke();
  },
  methods: {
    revoke() {
      if (this.pdfUrl) URL.revokeObjectURL(this.pdfUrl);
      this.pdfUrl = "";
    },
    setZoom(step) {
      this.zoomLevel = Math.min(200, Math.max(25, this.zoomLevel + step));
    },
    resetZoom() {
      this.zoomLevel = Number(this.zoom) || 75;
    },
    downloadPDF() {
      if (!this.blob) return;
      const a = document.createElement("a");
      a.href = URL.createObjectURL(this.blob);
      a.download = this.filename;
      document.body.appendChild(a);
      a.click();
      setTimeout(() => {
        URL.revokeObjectURL(a.href);
        a.remove();
      }, 1000);
    },
    printPDF() {
      const f = this.$refs.pdfFrame;
      if (!f) return;
      f.contentWindow.focus();
      f.contentWindow.print();
    },
    close() {
      this.$emit("input", false);
    },
  },
};
